import { SlotService } from '../state/types';
import { aggregateParticipantAddons } from '../payment/modifiers/aggregateParticipantAddons';

export type AddonLine = {
  quantity: number;
  name: string;
  price: number;
  currency: string;
};

/** All participants' add-ons summed per add-on, for the Payment Summary breakdown. */
export const getParticipantAddonLines = ({
  participants,
  addOnByGroup,
  paymentDetails,
}: SlotService): AddonLine[] => {
  if (!participants?.length || !addOnByGroup) {
    return [];
  }
  const selected = aggregateParticipantAddons(participants);
  return addOnByGroup.flatMap((group) =>
    (group.addOns ?? []).flatMap((addon) => {
      const selection = addon.id && selected[group.id!]?.[addon.id];
      return selection
        ? [
            {
              quantity: selection.quantity ?? 1,
              name: addon.name!,
              // The calculator charges the price stored on the selection, so the
              // summary reads it from there too; the catalog is only a fallback.
              price: Number(selection.price ?? addon.price) || 0,
              currency:
                selection.currency || addon.currency || paymentDetails.currency,
            },
          ]
        : [];
    }),
  );
};
